module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "media-piece"
    }
  }, [(_vm.showLoader) ? _c('loader-large') : _vm._e(), _vm._v(" "), (_vm.showPiece && _vm.piece) ? [(!_vm.canEdit && _vm.editMode) ? _c('div', {
    staticClass: "validation-messages error"
  }, [_c('h1', [_vm._v("You cannot edit this")])]) : [(_vm.editMode) ? _c('edit-form', {
    attrs: {
      "piece": _vm.piece
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.editMode) ? _c('media-post', {
    attrs: {
      "piece": _vm.piece,
      "medias-id": _vm.mediasId,
      "can-edit": _vm.canEdit,
      "classes": "centered"
    }
  }) : _vm._e()]] : _vm._e(), _vm._v(" "), (_vm.showPiece && !_vm.piece) ? _c('div', {
    staticClass: "validation-messages friendly"
  }, [_c('h1', [_vm._v("This piece doesn't exist")])]) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-037a483a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Common/Media/MediaPieceSingle.vue
// module id = 815
// module chunks = 2